/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
import { get } from 'lodash';
import React, { useEffect, useRef } from 'react';
import Toast, { BaseToast, ErrorToast, InfoToast } from 'react-native-toast-message';
// import Ionicons from '@expo/vector-icons/Ionicons';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { DefaultTheme, NavigationContainer } from '@react-navigation/native';
import {
  // CardStyleInterpolators,
  createStackNavigator,
  // HeaderStyleInterpolators,
  TransitionPresets,
  TransitionSpecs,
} from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { AppState, Linking, Text, View } from 'react-native';
import useNativeSafeInsets from 'src/common/hooks/useNativeSafeInsets';
import { ExitModal, IconButton, LoadingModalHOC } from 'src/components';
// import { InfoModal } from 'src/components/layout/InfoModal';
import { AppColors } from 'src/themes/Colors';
// import { TripListScreen } from 'src/screens';
import { IconSvg } from 'src/assets';
import { useGlobalSeatSelection } from 'src/common/hooks/socket/useGlobalSeatSelection';
import * as Screen from 'src/screens';
import { fontSizes, metrics, pixelScaler } from 'src/themes/Metrics';
import { DashboardStackParams } from './AppNavigationProps';
import { Navigation, navigationRef } from './RootNavigation';

// const HomeScreen = React.lazy(() => import('src/screens/home/HomeScreen'));
// const SelectSeatScreen = React.lazy(() => import('src/screens/selectSeat/SelectSeatScreen'));
// // const TripListScreen = React.lazy(() => import('src/screens/tripList/TripListScreen'));
// const TripDetailScreen = React.lazy(() => import('src/screens/tripDetail/TripDetailScreen'));
// const FilterScreen = React.lazy(() => import('src/screens/filter/FilterScreen'));
// const PassengerInfoScreen = React.lazy(() => import('src/screens/passengerInfo/PassengerInfoScreen'));
// const ConfirmPaymentScreen = React.lazy(() => import('src/screens/confirmPayment/ConfirmPaymentScreen'));
// const MyTicketScreen = React.lazy(() => import('src/screens/myTicket/MyTicketScreen'));
// const TravelHistoryScreen = React.lazy(() => import('src/screens/travelHistory/TravelHistoryScreen'));
// const HistoryDetailScreen = React.lazy(() => import('src/screens/historyDetail/HistoryDetailScreen'));
// const ListingStoreScreen = React.lazy(() => import('src/screens/listingStore/ListingStoreScreen'));
// const ListingFoodScreen = React.lazy<any>(() => import('src/screens/listingFood/ListingFoodScreen'));

// const DashboardNativeStack = createNativeStackNavigator<DashboardStackParams>();
const DashboardNativeStack = createStackNavigator<DashboardStackParams>();

const DashboardStack = () => {
  const insets = useNativeSafeInsets();
  const { t } = useTranslation();
  const [isExit, setIsExit] = React.useState<boolean>(false);

  // const [infoModalVisible, setInfoModalVisible] = React.useState<boolean>(false);

  // const handleCloseInfoModal = () => setInfoModalVisible(false);
  // const handleOpenInfoModal = () => setInfoModalVisible(true);

  const handleClose = () => setIsExit(false);
  // const handleOpenExitModal = () => setIsExit(true);

  const homeHeaderLeft = () => (
    <IconButton
      style={{ marginLeft: metrics.medium }}
      icon={<MaterialIcons name="arrow-back" size={pixelScaler(24)} color="white" />}
      onPress={() => Navigation.pop()}
    />
  );
  const headerExitLeft = () => (
    <IconButton
      style={{ marginLeft: metrics.medium }}
      icon={<MaterialIcons name="arrow-back" size={pixelScaler(24)} color="white" />}
      onPress={() => window?.nham24?.request('app/close', {})}
    />
  );

  const homeHeaderRight = () => (
    <IconButton
      style={{ backgroundColor: AppColors.white67, width: pixelScaler(36), height: pixelScaler(36), borderRadius: 30 }}
      icon={<IconSvg.History fill={AppColors.black} />}
      onPress={() => Navigation.navigate('TravelHistoryScreen')}
    />
    // <Row>
    //   <TouchableOpacity
    //     activeOpacity={0.8}
    //     style={{
    //       borderRadius: 20,
    //       alignItems: 'center',
    //       justifyContent: 'center',
    //       flexDirection: 'row',
    //       backgroundColor: AppColors.black50,
    //       paddingHorizontal: metrics.large,
    //       height: pixelScaler(28),
    //       borderWidth: 1,
    //       borderColor: AppColors.white,
    //     }}
    //     onPress={() => Navigation.navigate('TravelHistoryScreen')}>
    //     <IconSvg.Ticket fill={AppColors.white} />
    //     <SizedBox height={0} width="small" />
    //     <RegularText color={AppColors.white} fontWeight="bold" fontSize="medium">
    //       {t('viewTicket')}
    //     </RegularText>
    //   </TouchableOpacity>
    // </Row>
  );

  // const homeTripListHeaderRight = () => (
  //   <IconButton
  //     icon={<Icon name="icon-filter" size={pixelScaler(24)} color="white" />}
  //     onPress={() => Navigation.navigate('FilterScreen')}
  //   />
  // );

  // from={{ opacity: 0, translateX: device.width }}
  //       animate={{ opacity: 1, translateX: 0 }}
  //       transition={{
  //         type: 'timing',
  //         duration: 1,
  //       }}>
  const stackAnimation = React.useCallback(() => {
    if (get(window, 'nham24.platform') === 'android') {
      return TransitionPresets.FadeFromBottomAndroid;
    }

    return TransitionPresets.SlideFromRightIOS;
  }, [get(window, 'nham24.platform')]);

  return (
    <>
      <DashboardNativeStack.Navigator
        screenOptions={{
          cardStyle: { flex: 1 },
          headerStatusBarHeight: insets.top,
          headerStyle: {
            backgroundColor: AppColors.primary,
          },
          headerTitleContainerStyle: {
            marginLeft: metrics.small,
          },
          headerLeft: homeHeaderLeft,
          headerRightContainerStyle: {
            paddingRight: metrics.large,
          },
          headerTintColor: 'white',
          headerTitleAlign: 'left',
          animationEnabled: true,
          ...stackAnimation(),
          transitionSpec: {
            open: TransitionSpecs.TransitionIOSSpec,
            close: {
              animation: 'timing',
              config: {
                duration: 0,
              },
            },
          },
        }}
        initialRouteName="LoginScreen">
        <DashboardNativeStack.Screen
          options={{
            title: t('bus'),
            headerLeft: headerExitLeft,
            headerRight: homeHeaderRight,
            headerTransparent: true,
          }}
          name="LoginScreen"
          component={Screen.LoginScreen}
        />

        <DashboardNativeStack.Screen name="SelectSeatScreen" component={Screen.SelectSeatScreen} />
        <DashboardNativeStack.Screen
          options={{
            title: t('selectSeat'),
          }}
          name="ReturnSelectSeatScreen"
          component={Screen.ReturnSelectSeatScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            // headerRight: homeTripListHeaderRight,
            headerTitleAlign: 'center',
            headerTitleContainerStyle: {
              paddingLeft: metrics.medium,
            },
          }}
          // initialParams={SearchParams}
          name="TripListScreen"
          component={Screen.TripListScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            // headerRight: homeTripListHeaderRight,
            headerTitleAlign: 'center',
            headerTitleContainerStyle: {
              paddingLeft: metrics.medium,
            },
          }}
          name="ReturnTripListScreen"
          component={Screen.ReturnTripListScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            headerTransparent: true,
            title: t('tripDetails'),
          }}
          name="TripDetailScreen"
          component={Screen.TripDetailScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            title: t('filter'),
          }}
          name="FilterScreen"
          component={Screen.FilterScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            title: t('passengerInformation'),
          }}
          name="PassengerInfoScreen"
          component={Screen.PassengerInfoScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            title: t('confirmPayment'),
          }}
          name="ConfirmPaymentScreen"
          component={Screen.ConfirmPaymentScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            title: t('ticket'),
            headerShadowVisible: false,
          }}
          name="MyTicketScreen"
          component={Screen.MyTicketScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            title: t('history'),
          }}
          name="TravelHistoryScreen"
          component={Screen.TravelHistoryScreen}
        />
        {/* <DashboardNativeStack.Screen
          options={{
            title: t('history'),
          }}
          name="HistoryDetailScreen"
          component={Screen.HistoryDetailScreen}
        /> */}
        <DashboardNativeStack.Screen
          options={{
            headerTitleAlign: 'left',
            title: t('coupon'),
            headerStyle: {
              borderBottomWidth: 0,
              backgroundColor: AppColors.primary,
            },
            // headerTitleContainerStyle: {
            //   width: device.width * 0.8,
            // },
          }}
          name="CouponScreen"
          component={Screen.CouponScreen}
        />
        <DashboardNativeStack.Screen
          options={{
            headerTitleAlign: 'left',
            title: t('cancellationPolicy'),
          }}
          name="CancellationPolicyScreen"
          component={Screen.CancellationPolicyScreen}
        />

        {/* <DashboardNativeStack.Screen
          options={{
            title: 'Listing Store',
          }}
          name="ListingStoreScreen"
          component={Screen.ListingStoreScreen}
        />
        <DashboardNativeStack.Screen options={{}} name="ListingFoodScreen" component={Screen.ListingFoodScreen} /> */}
      </DashboardNativeStack.Navigator>
      <ExitModal onClose={handleClose} isVisible={isExit} />
      {/* <InfoModal onClose={handleCloseInfoModal} isVisible={infoModalVisible} /> */}
      <Toast
        config={{
          success: props => {
            return (
              <BaseToast
                {...props}
                style={{ borderLeftColor: AppColors.primary }}
                text2NumberOfLines={3}
                text1Style={{
                  fontSize: fontSizes.large,
                }}
                text2Style={{
                  fontSize: fontSizes.regular,
                }}
              />
            );
          },
          info: props => {
            return (
              <InfoToast
                {...props}
                style={{ borderLeftColor: AppColors.yellow }}
                text2NumberOfLines={3}
                text1Style={{
                  fontSize: fontSizes.large,
                }}
                text2Style={{
                  fontSize: fontSizes.regular,
                }}
              />
            );
          },
          error: props => {
            return (
              <ErrorToast
                {...props}
                text1Style={{
                  fontSize: fontSizes.large,
                }}
                text2NumberOfLines={3}
                text2Style={{
                  fontSize: fontSizes.regular,
                }}
              />
            );
          },
        }}
      />
    </>
  );
};

const AppNavigation = () => {
  // const insets = useNativeSafeInsets();
  useGlobalSeatSelection();
  const [isReady, setReady] = React.useState(false);
  const appState = useRef(AppState.currentState);
  const [version, setVersion] = React.useState<string>('DEV');

  // useEffect(() => {
  //   setTimeout(() => {
  //     setReady(true);
  //   }, 1);
  // }, []);

  useEffect(() => {
    const subscription = AppState.addEventListener('change', nextAppState => {
      if (appState.current.match(/inactive|background/) && nextAppState === 'active') {
        // call api to fetch if seat is busy

        return;
      }
      appState.current = nextAppState;
    });

    return () => {
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    window.addEventListener('app/android-back', () => {
      window?.nham24?.request('consolelog', navigationRef.getState());
      const { index, routes } = navigationRef.getState();

      if (routes[index].name === 'LoginScreen') {
        window?.nham24?.request('app/close', {});
      } else {
        // navigationRef.current
        navigationRef.goBack();
      }
    });
    Linking.getInitialURL().then(url => {
      // console.log({ url });
      const version = url?.split('?v=') || [];
      if (version.length >= 2) {
        setVersion(version[1]);
      }
    });

    return () => {
      window.removeEventListener('app/android-back', navigationRef.goBack);
    };
  }, []);

  return (
    <NavigationContainer onReady={() => setReady(true)} ref={navigationRef} theme={appTheme} linking={{ prefixes: [] }}>
      {/* <SafeAreaView style={{ flex: 1, paddingTop: insets?.top, backgroundColor: AppColors.primary }}> */}
      <LoadingModalHOC>
        {isReady ? <DashboardStack /> : <View />}
        {/* <RegularText style={{ position: 'absolute', bottom: 10, left: 10 }}>V1.0.0</RegularText> */}
      </LoadingModalHOC>
      {/* </SafeAreaView> */}
      <Text style={{ fontSize: 12, color: AppColors.gray, position: 'absolute', bottom: 6, right: 20 }}>{version}</Text>
    </NavigationContainer>
  );
};

const appTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    ...AppColors,
  },
};

export default AppNavigation;
